var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"intersect",rawName:"v-intersect",value:(_vm.onIntersect),expression:"onIntersect"}],staticClass:"page-header-intersector"}),_vm._v(" "),(!_vm.isIntersecting)?_c('heading',_vm._b({attrs:{"fixed":"","is-editing":_vm.isEditing},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._t("default")]},proxy:true},{key:"actions",fn:function(){return [_vm._t("actions")]},proxy:true}],null,true)},'heading',{
				backUrl: _vm.backUrl,
				description: _vm.description,
				fluid: _vm.fluid,
				title: _vm.title,
				status: _vm.status,
				statusColor: _vm.statusColor,
				subTitle: _vm.subTitle
			},false)):_vm._e(),_vm._v(" "),_c('heading',_vm._b({attrs:{"is-editing":_vm.isEditing},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._t("default")]},proxy:true},(_vm.isIntersecting)?{key:"actions",fn:function(){return [_vm._t("actions")]},proxy:true}:null],null,true)},'heading',{
				backUrl: _vm.backUrl,
				description: _vm.description,
				fluid: _vm.fluid,
				title: _vm.title,
				status: _vm.status,
				statusColor: _vm.statusColor,
				subTitle: _vm.subTitle
			},false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }